import { render, staticRenderFns } from "./AdminUserAddNew.vue?vue&type=template&id=6510eaa2&scoped=true"
import script from "./AdminUserAddNew.vue?vue&type=script&lang=js"
export * from "./AdminUserAddNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6510eaa2",
  null
  
)

export default component.exports